module.exports = __webpack_public_path__ + "static/media/44546830_2199901190085060_8604371226917339136_o.21727070.jpg";